export default __webpack_public_path__ + "static/media/medicare1.16f28700.jpg";